import { render, staticRenderFns } from "./InPageMessage.vue?vue&type=template&id=00c144ec"
import script from "./InPageMessage.vue?vue&type=script&lang=js"
export * from "./InPageMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports